import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { EntityType } from '../../../../../api/targeting/enum/entity.type.enum';
import { PortfolioCategory } from '../../../enums/portfolio-category.enum';
import { PortfolioRegion } from '../../../enums/portfolio-region.enum';
import { PortfolioService } from '../portfolio-service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-portfolio-hype',
    templateUrl: './portfolio-hype.component.html',
    styleUrls: ['./portfolio-hype.component.scss'],
    standalone: false
})

export class PortfolioHypeComponent {

    readonly entityTypes = EntityType;
    readonly portfolioCategories = PortfolioCategory;
    readonly portfolioRegions = PortfolioRegion;
    readonly buttonTypes = ButtonTypesEnum;

    public constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public portfolioService: PortfolioService) {

    }
}
